import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi) // This allows loading translations via HTTP
  .use(LanguageDetector) // Automatically detects user language
  .use(initReactI18next) // Integrates i18next with React
  .init({
    fallbackLng: 'en', // Fallback language if the desired language is not available
    supportedLngs: ['en', 'fr', 'es', 'de'], // List of supported languages
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to your translation files
    },
    ns: ['login'], // Specify that 'login' is a namespace
    defaultNS: 'login', // Set the default namespace to 'login'
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
